export default {
      id: "arrow_black_left-usage",
      viewBox: "0 0 5 7",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow_black_left",
      toString: function () {
        return this.url;
      }
    }